import React, { Component } from 'react'

class MainContainer extends Component {
    render() {
        return ( <div className="page-container"></div> )
    }
}

export default MainContainer;